<template>
  <div>
    <div class="mobile">
      <section class="m-hero">
        <h1>Checker</h1>
        <p>우리 집 방범 도어 가드</p>
      </section>
      <section class="m-checker-description-first">
        <div class="m-description-container-center">
          <span>스마트폰 앱으로
            <br>내 집 보안 챙기세요</span>
          <p>
            체커는 앱으로 현관문/창문의 출입을
            <br>확인할 수 있고, 침입감지 시 경보음을 울려 주변에
            <br>비상상황을 알릴 수 있습니다.
          </p>
        </div>
        <img style="display: block; width: 46px; margin:0 auto;" src="@/assets/bell.gif" alt="">
        <img style="margin-top: 40px; width: 230px;" src="@/assets/checker/checker-app.png" alt>
      </section>
      <section class="m-checker-description-section">
        <div class="m-description-container">
          <span>너무나 쉬운 빈집 보안</span>
          <p>설치비 X, 기사 방문 X, 약정 X
            <br>원하는 곳에 부착하면 끝.
            <br>30초면 충분해요.
          </p>
        </div>
        <div class="video-wrapper">
          <div class="video-cover" @click="playBtnClick" v-bind:class="{removeCover: isPlaying}">
            <div class="play-icon"></div>
          </div>
          <iframe
            id="ytplayer"
            type="text/html"
            width="205"
            height="315"
            src="https://www.youtube.com/embed/aMgVjwnmid4?start=4"
            frameborder="0"
          />
        </div>
      </section>
      <section class="m-checker-description-section">
        <div class="m-description-container">
          <span>인정받은 방범 능력</span>
          <p>체커는 지역 경찰과 함께 보안 취약 지역의
            <br>방범을 책임지고 있습니다.
          </p>
        </div>
      </section>
      <section class="m-checker-description-image-section" id="m-police">
        <img src="@/assets/checker/police-checker1.png" alt="">
        <img src="@/assets/checker/police-checker2.png" alt="">
      </section>
      <section class="m-checker-description-second">
        <div class="m-description-container-center">
          <span>침입자를 쫓아내는 체커</span>
          <p>
            체커는 문 열림을 감지하여
            <br>알림을 줄 뿐 아니라
            <br>침입자를 쫓아낼 수 있는
            <br>강력한 *경보음을 울립니다.
            <br>
            <br>*약 100dB(데시벨)로 기차 소리와
            <br>비슷한 크기입니다.
          </p>
        </div>
      </section>
      <section class="m-checker-description-image-section" id="m-siren">
        <img src="@/assets/checker/m-checker-siren.png" alt="">
      </section>
      <section class="m-checker-description-fourth">
        <div class="m-description-container">
          <span>빈집을 확실히
            <br>지키는 경계 모드</span>
          <p>
            출근시간, 빈집에 누가 들어온다면?
            <br>원하는 시간에 경계 예약을 해두면
            <br>즉각 휴대폰 알람과
            <br>강력한 경보음을 울릴 수 있습니다.
          </p>
        </div>
      </section>
      <section class="m-checker-description-ninth">
        <div class="m-description-container">
          <span>3시간 충전, 100일의 안심</span>
          <p>
            체커는 방범을 위한 제품인 만큼
            <br>긴 사용시간을 자랑합니다.
            <br>3시간만 충전하면 약 100일 동안 문제없죠.
            <br>배터리 잔량은 앱에서 확인하세요.
          </p>
        </div>
      </section>
      <section class="m-checker-description-tenth"></section>
      <section class="m-checker-description-eleventh">
        <div class="m-description-container">
          <span>의외의 장소에도 융통성 있게</span>
          <p>
            열렸을 때 2cm 이상 거리가 생기는 모든 공간,
            <br>사물에 부착이 가능해요.
            <br>그래서 문과 창문이 아닌 곳에도 설치가 가능하죠.
            <br>냉장고, 사물함, 서랍, 보석함, 안전펜스 등
            <br>마음껏 응용해보세요.
          </p>
        </div>
      </section>
      <section class="m-checker-description-twelfth"></section>
      <section class="m-checker-description-thirteenth">
        <div class="m-description-container">
          <span>
            체커를 전용 앱으로 사용하세요.
            <br>앱을 다운받으면 휴대폰으로
            <br>실시간 모니터링, 침입 감지가 가능합니다
          </span>
          <div class="button-wrapper">
            <a
              href="https://itunes.apple.com/kr/app/%EC%8A%A4%EC%9C%84%EC%B2%98/id1085468372?mt=8"
              target="_blank"
            >
              <div class="app-button">
                <img style="width: 18px; height: 20px;" src="@/assets/main/app-store.png" alt>
                <span>App Store</span>
              </div>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=kr.switcher.switcherm&hl=ko"
              target="_blank"
              class="hideAll"
            >
              <div class="app-button">
                <img style="width: 16px; height: 19px;" src="@/assets/main/google-play.png" alt>
                <span>Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section class="m-checker-description-fourteenth">
        <div class="m-description-container">
          <span>
            Switcher와의 조합,
            <br>나에게 딱 맞는 방범 시스템
          </span>
          <div>
            <span>
              자동으로 전등을 껐다 켰다 할 수 있는
              <br>스위처와 체커가 결합하면 최적의 방범
              <br>시스템을 구축할 수 있어요.
              <br>어둠을 밝혀주는 스위처와, 창문을 지키는 체커.
              <br>이보다 든든할 수는 없겠죠.
            </span>
          </div>
          <div class="go-switcher-button" @click="goSwitcher">
            <span>Switcher 바로가기</span>
          </div>
        </div>
      </section>
      <section class="m-usecase">
        <div class="m-usecase-container">
          <h3>
            Checker 이렇게
            <br>활용해 보세요
          </h3>
          <div class="m-usecase-contents">
            <span>
              개인 서랍, 금고 등 보안이 필요한 곳에
              <br>응용하여 설치해보세요
            </span>
            <p>
              열리고 닫히는 모든 공간, 사물에 설치가 가능합니다.
              <br>내 비밀을 간직한 책상 서랍이나 공공장소의 개인 라커
              <br>안쪽에 체커를 붙여보세요.
              <br>나만의 금고가 되어 줄 거예요.
            </p>
          </div>
          <div class="m-usecase-contents">
            <span>체커는 침입자를 지키는 데도 할용할 수 있어요</span>
            <p>
              어린아이가 위험한 물건이 담긴 서랍을 열때,
              <br>안전펜스를 열고 넘어갈 때,
              <br>고양이가 간식 상자를 뒤질 때, 경보음 소리와 함께
              <br>휴대폰으로 메시지가 옵니다.
              <br>위험한 물건, 탐나는 물건을 지켜보세요.
            </p>
          </div>
        </div>
      </section>
    </div>
    <div class="desktop">
      <section class="hero">
        <div class="main-title-container">
          <span>우리 집 도어 가드</span>
        </div>
      </section>
      <section class="checker-description-first">
        <div style="margin-top: 70px;">
          <span class="center-title">스마트폰 앱으로 내 집 보안 챙기세요</span>
          <p class="center-subtitle">
            <br>체커는 앱으로 현관문/창문의 출입을 확인할 수 있고
            <br>침입감지 시 경보음을 울려 주변에 비상상황을 알릴 수 있습니다.
          </p>
          <img src="@/assets/bell.gif" style="width: 60px; height: 60px; margin-top: 20px;" alt>
          <p style="font-size: 12px; margin-top: 8px; color: #868fa3;">경보음</p>
          <img style="width: 250px;" src="@/assets/checker/checker-app.png" alt>
        </div>
      </section>
      <section class="checker-description" id="install">
        <div>
          <span class="description-title">너무나 쉬운 빈집 보안</span>
          <p class="description-subtitle">
            설치비 X, 기사 방문 X, 약정 X 원하는 곳에 부착하면 끝.
            <br>30초면 충분해요.
          </p>
        </div>
        <div class="video-wrapper" style="width: 385px !important; margin: 0 !important;">
          <div class="video-cover" @click="playBtnClick" v-bind:class="{removeCover: isPlaying}">
            <div class="play-icon"></div>
          </div>
          <iframe
            id="ytplayer"
            type="text/html"
            width="385"
            height="585"
            src="https://www.youtube.com/embed/aMgVjwnmid4?start=4"
            frameborder="0"
          />
        </div>
      </section>
      <section class="checker-description" id="police">
        <div style="margin-right: 20%">
          <span class="description-title">인정받은 방범 능력</span>
          <p class="description-subtitle">
            체커는 지역 경찰과 함께 보안 취약 지역의 방범을
            <br>책임지고 있습니다.
          </p>
        </div>
      </section>
      <section class="checker-description" id="siren">
        <div style="text-align: left;">
          <span class="description-title">침입자를 쫓아내는 체커</span>
          <p class="description-subtitle">
            체커는 문열림을 감지하여 알림을 줄 뿐만 아니라
            <br>침입자를 쫓아낼 수 있는 강력한 *경보음을 울릴 수 있습니다.
            <br><br>*약 100dB 크기
          </p>
        </div>
        <img style="width: 628px; margin-left: 10%;" src="@/assets/checker/checker-siren.png">
      </section>
      <section class="checker-description" id="schedule">
        <img style="width: 628px; margin-right: 10%;" src="@/assets/checker/checker-schedule.png">
        <div style="text-align: left;">
          <span class="description-title">빈집을 확실히 지키는 경계 모드</span>
          <p class="description-subtitle">
            출근시간, 빈집에 누가 들어온다면?
            <br>원하는 시간에 경계 예약을 해두면
            <br>즉각 휴대폰으로 알람이 오고
            <br>강력한 경보음을 원격으로 울릴 수 있습니다.
          </p>
        </div>
      </section>
      <section class="checker-description-fifth">
        <div>
          <span class="description-title">무빙 포인트, 픽스 포인트에 붙이기만 하세요</span>
          <p class="description-subtitle">
            <br>움직이는 곳에 마그넷를, 고정되는 면에 본체를 붙여주세요.
            <br>무빙 포인트는 문, 픽스 포인트는 문틀을 추천합니다.
            <br>창문의 경우 두 창이 만나는 곳에 부착하면
            <br>양쪽 창문의 개폐를 하나의 체커로 확인할 수 있죠.
            <br>
            <br>부착 위치에 체커의 사이즈가 맞다면
            <br>여닫이, 슬라이딩, 상하 개폐식, 어떤 형태의 문에도
            <br>응용 설치가 가능해요.
          </p>
        </div>
      </section>
      <section class="checker-description-sixth">
        <div>
          <span class="description-title">3시간 충전, 100일의 안심</span>
          <p class="description-subtitle">
            체커는 방범을 위한 제품인 만큼 긴 사용시간을 자랑합니다.
            <br>3시간만 충전하면 약 100일 동안 문제없죠.
            <br>배터리 잔량은 앱에서 확인하세요.
          </p>
        </div>
      </section>
      <section class="checker-description-seventh">
        <div>
          <span class="description-title">의외의 장소에도 융통성 있게</span>
          <p class="description-subtitle">
            체커의 본체와 마그넷은 2cm 이상 멀어지면 움직임을 감지합니다.
            <br>열렸을 때 2cm 이상 거리가 생기는 모든 공간, 사물에 부착이 가능해요.
            <br>그래서 문과 창문이 아닌 곳에도 설치가 가능하죠
            <br>냉장고, 사물함, 서랍, 보석함, 안전펜스, 마음껏 응용해보세요.
            <br>
          </p>
        </div>
      </section>
      <section class="checker-description-eighth">
        <div>
          <span>
            체커를 전용 앱으로 사용하세요
            <br>앱을 다운받으면 휴대폰으로 실시간 모니터링,
            <br>침입 감지가 가능합니다
          </span>
        </div>
        <div class="button-wrapper">
          <a
            href="https://itunes.apple.com/kr/app/%EC%8A%A4%EC%9C%84%EC%B2%98/id1085468372?mt=8"
            target="_blank"
          >
            <div class="app-button">
              <img style="width: 18px; height: 20px;" src="@/assets/main/app-store.png" alt>
              <span style="font-size: 14px">App Store</span>
            </div>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=kr.switcher.switcherm&hl=ko"
            target="_blank"
            class="hideAll"

          >
            <div class="app-button">
              <img style="width: 16px; height: 19px;" src="@/assets/main/google-play.png" alt>
              <span style="font-size: 14px">Google Play</span>
            </div>
          </a>
        </div>
      </section>
      <section class="checker-description-ninth">
        <div>
          <span class="center-title">Switcher와의 조합, 나에게 딱 맞는 방범 시스템</span>
          <p class="center-subtitle">
            자동으로 전등을 껐다 켰다 할 수 있는 스위처와 체커가 결합하면 최적의 방범 시스템을 구축할 수 있어요.
            <br>어둠을 밝혀주는 스위처와, 창문을 지키는 체커. 이보다 든든할 수는 없겠죠.
          </p>
          <div @click="goSwitcher" class="go-switcher" style="cursor: pointer">Switcher 바로가기</div>
        </div>
      </section>
      <section class="checker-description-tenth">
        <div>
          <span class="usecase-title">
            Checker 이렇게
            <br>활용해 보세요
          </span>
        </div>
        <div class="usecase-wrapper">
          <div class="usecase-contents" style="margin-top: 0;">
            <span>개인 서랍, 금고 등 보안이 필요한 곳에 응용하여 설치해보세요</span>
            <p>
              열리고 닫히는 모든 공간, 사물에 설치가 가능합니다.
              <br>내 비밀을 간직한 책상 서랍이나 공공장소의 개인 라커 안쪽에 체커를 붙여보세요.
              <br>나만의 금고가 되어 줄 거예요.
            </p>
          </div>
          <div class="usecase-contents">
            <span>체커는 침입자를 지키는 데도 활용할 수 있어요</span>
            <p>
              어린아이가 위험한 물건이 담긴 서랍을 열 때, 안전펜스를 열고 넘어갈 때,
              <br>고양이가 간식 상자를 뒤질 때, 경보음 소리와 함께 휴대폰으로 메시지가 옵니다.
              <br>위험한 물건, 탐나는 물건을 지켜보세요.
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: 'checker-summary',
  data () {
    return {
      isPlaying: false
    }
  },
  methods: {
    goSwitcher: function () {
      this.$router.push({ 'name': 'Switcher' })
    },
    playBtnClick: function () {
      this.isPlaying = true
    }
  }
}
</script>
<style scoped>

.desktop section {
  margin-bottom: 30px;
}

.hero {
  background: url("../../../assets/checker/checker-hero.png") no-repeat center
    center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}

.hero span {
  font-size: 24px;
  font-weight: bold;
  line-height: 1.58;
  letter-spacing: 0;
}

.description-title {
  font-size: 24px;
  font-weight: 500;
}
.description-subtitle {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.62;
  margin-top: 13px;
}
.center-title {
  font-size: 24px;
  letter-spacing: 0;
  font-weight: 500;
}
.center-subtitle {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.62;
  margin-top: 15px;
}

#install {
  min-height: 654px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
#police {
  background: url("../../../assets/checker/police.png") no-repeat center center;
  background-size: cover;
  min-height: 570px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
#siren {
  min-height: 570px;
  display: flex;
  align-items: center;
  justify-content: center;
}
#schedule {
  min-height: 570px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.checker-description-first {
  width: 100%;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.checker-description-fifth {
  background: url("../../../assets/checker/checker-description-fifth.png")
    no-repeat center center;
  background-size: cover;
  min-height: 618px;
  display: flex;
  align-items: center;
}

.checker-description-fifth div {
  text-align: left;
  margin-left: 15%;
}

.checker-description-sixth {
  background: url("../../../assets/checker/checker-description-sixth.png")
    no-repeat center center;
  background-size: cover;
  min-height: 510px;
  display: flex;
  flex-flow: row-reverse;
  align-items: center;
}
.checker-description-sixth div {
  text-align: left;
  flex: 0.38;
}

.checker-description-seventh {
  background: url("../../../assets/checker/checker-description-seventh.png")
    no-repeat center center;
  background-size: cover;
  min-height: 563px;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.checker-description-seventh div {
  text-align: left;
  margin-left: 15%;
}

.checker-description-eighth {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 360px;
}
.checker-description-eighth span {
  font-size: 20px;
  line-height: 1.7;
  color: #3d4953 !important;
 }
.checker-description-eighth .button-wrapper {
  display:flex;
}

.checker-description-ninth {
  background: url("../../../assets/checker/checker-description-ninth.png")
    no-repeat center center;
  background-size: cover;
  min-height: 807px;
  display: flex;
  justify-content: center;
}
.checker-description-ninth div {
  margin-top: 80px;
}

.checker-description-ninth .go-switcher {
  width: 180px;
  height: 50px;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 27px auto;
  font-size: 15px;
  font-weight: 500;
}

.checker-description-ninth .go-switcher:hover {
  border: solid 1px #3d4953;
}

.button-wrapper {
  display: inline-block;
  margin-top: 36px;
}
.button-wrapper div {
  margin: 7px;
  color: #3d4953;
}

.app-button:hover {
  border: solid 1px #3d4953;
}

.checker-description-tenth {
  width: 100%;
  display: flex;
  background-color: #fafafa;
  justify-content: space-evenly;
  padding-top: 100px;
  padding-bottom: 100px;
}
.app-button {
  width: 158px;
  height: 50px;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-button:hover {
  border: solid 1px #3d4953;
}

.app-button span {
  font-size: 16px !important;

}
.app-button img {
  margin-right: 7px;
}

.desktop .usecase-contents {
  text-align: left;
}
.desktop .usecase-contents p {
  font-weight: 400;
}
.usecase-contents {
  font-size: 16px;
  line-height: 1.71;
  margin-top: 39px;
}
.usecase-contents span {
  font-weight: bold;
}
.usecase-contents p {
  margin-top: 9px;
}
.usecase-contents a {
  font-size: 12px;
  letter-spacing: -0.4px;
  color: #3d4953;
  text-decoration: underline;
}

.main-title-container {
  text-align: left;
  margin-left: 10%;
}
.m-hero {
  background: url("../../../assets/checker/m-checker-hero.png") no-repeat center
    center;
  background-size: cover;
  min-height: 470px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}
.m-hero h1 {
  font-size: 18px;
  font-weight: bold;
  color: #3d4953;
}
.m-hero p {
  margin-top: 24px;
  font-size: 18px;
  line-height: 1.56;
  color: #3d4953;
}

.m-description-container {
  text-align: left;
}

.m-description-container span {
  font-size: 18px;
  line-height: 1.56;
  letter-spacing: 0;
}
.m-description-container p {
  margin: 23px 0px 0px 0px;
  font-size: 14px;
  line-height: 1.71;
  letter-spacing: 0;
}

.m-description-container-center {
  text-align: center;
}

.m-description-container-center span {
  font-size: 18px;
}

.m-description-container-center p {
  font-size: 14px;
  margin-top: 19px;
}

.m-checker-description-image-section {
  width: 100%;
}
.m-checker-description-image-section img {
  width: 100%;
}
#m-police {
  margin-top: 61px;
}
#m-siren {
  margin-top: 40px;
}
.m-checker-description-section {
  padding: 63px 0px 0px 25px;

}
.m-checker-description-first {
  width: 100%;
  min-height: 519px;
  padding-top: 71px;
}
.m-checker-description-first .m-description-container {
  margin-left: 25px;
}
.m-checker-description-second {
  background-color: #fff;
  padding-top: 71px;
}
.m-checker-description-second .m-description-container {
  margin-left: 25px;
}

.m-checker-description-fourth {
  background: url("../../../assets/checker/m-checker-schedule.png") no-repeat center center;
  background-size: cover;
  min-height: 680px;
  padding:0px 0px 63px 25px;
  display: flex;
  align-items: flex-end;
}
.m-checker-description-ninth {
  min-height: 250px;
  padding: 71px 0px 0px 25px;
}
.m-checker-description-tenth {
  min-height: 250px;
  padding: 71px 0px 0px 25px;
}
.m-checker-description-tenth {
  background: url("../../../assets/checker/m-checker-description-tenth.png")
    no-repeat center center;
  background-size: cover;
  min-height: 353px;
}
.m-checker-description-eleventh {
  min-height: 250px;
  padding: 71px 0px 0px 25px;
  background-color: #463122;
  color: #ffffff;
}
.m-checker-description-twelfth {
  background: url("../../../assets/checker/m-checker-description-twelfth.png")
    no-repeat center center;
  background-size: cover;
  min-height: 272px;
}
.m-checker-description-thirteenth {
  min-height: 497px;
  display: flex;
  align-items: center;
}
.m-checker-description-thirteenth .m-description-container {
  text-align: center;
}
.m-checker-description-fourteenth {
  background: url("../../../assets/checker/m-checker-description-fourteenth.png") no-repeat
    center center;
  background-size: cover;
  min-height: 695px;
  padding-top: 60px;
}
.m-checker-description-fourteenth .m-description-container {
  text-align: center;
  color: #3d4953;
}
.m-checker-description-fourteenth .m-description-container div {
  line-height: 1.71;
  margin-top: 26px;
}

.m-checker-description-fourteenth .m-description-container div span {
  font-size: 14px;
}

.go-switcher-button {
  width: 158px;
  height: 50px;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  display: flex;
  align-items: center;
  font-size: 14px;
  justify-content: center;
  margin: 0 auto;
}

.app-button {
  width: 158px;
  height: 50px;
  border-radius: 2px;
  border: solid 1px #a5a5a5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-button img {
  margin-right: 7px;
}

.m-usecase {
  background-color: #fafafa;
  padding: 73px 0px 110px 25px;
}

.m-usecase-container {
  text-align: left;
}
.m-usecase-container h3 {
  font-size: 18px;
  line-height: 1.56;
}
.m-usecase-container span {
  line-height: 1.56;
}
.m-usecase-contents {
  font-size: 14px;
  line-height: 1.71;
  margin-top: 39px;
}
.m-usecase-contents span {
  font-weight: bold;
}
.m-usecase-contents p {
  margin-top: 9px;
}
.m-usecase-contents a {
  font-size: 12px;
  letter-spacing: -0.4px;
  color: #3d4953;
  text-decoration: underline;
}

.checker-description-tenth div {
  text-align: left;
  font-weight: 500;
}
.checker-description-tenth .usecase-title {
  font-size: 24px;
}

iframe {
  width: 100%;
}

.video-wrapper {
  position: relative;
  width: 210px;
  margin: 0 auto;
  margin-top: 30px;
}

.video-wrapper .video-cover {
  background: url("../../../assets/checker/checker-youtube-cover.png") no-repeat center center;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-wrapper .video-cover:hover .play-icon {
  opacity: 1;
}
.play-icon {
  background: url("../../../assets/linker/play-btn.png") no-repeat center;
  background-size: cover;
  width: 60px;
  height: 60px;
  opacity: 0.5;
}
.removeCover {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/products/checker/CheckerSummary.vue